import { render } from "./GsuiteBill.vue?vue&type=template&id=0aff7a37&ts=true"
import script from "./GsuiteBill.vue?vue&type=script&lang=ts"
export * from "./GsuiteBill.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__